import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { IncomeListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { IncomeService } from './income.service';
import { SharedModule } from '../shared/shared.module';
import { IncomeCreateComponent } from './create/create.component';
import { IncomeFormComponent } from './form/form.component';
import { IncomeEditComponent } from './edit/edit.component';

const routes: Routes = [
  { path: 'incomes', component: IncomeListComponent, canActivate: [AuthGuard] },
  {
    path: 'incomes/create',
    component: IncomeCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'incomes/:id/edit',
    component: IncomeEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    IncomeListComponent,
    IncomeCreateComponent,
    IncomeFormComponent,
    IncomeEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, IncomeService],
})
export class IncomeRoutingModule {}
